import React, { useEffect } from "react";
import "./css/TemplatePreviewModal.css";

const titleMap = {
  templatefile1: "Header Template",
  templatefile2: "Line Item Template",
};

export default function TemplatePreviewModal({
  open,
  onClose,
  templateHtml = {},
  invoiceNo = "",
  materialService = "",
}) {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="template-preview-overlay">
      <div className="template-preview-modal">

        <div className="template-preview-header">
          <div>
            <h2>Template Preview</h2>

            {(invoiceNo || materialService) && (
              <p>
                {invoiceNo && (
                  <>
                    <strong>Invoice:</strong> {invoiceNo}
                  </>
                )}

                {invoiceNo && materialService && " | "}

                {materialService && (
                  <>
                    <strong>Type:</strong>{" "}
                    {materialService.charAt(0).toUpperCase() +
                      materialService.slice(1)}
                  </>
                )}
              </p>
            )}
          </div>

          <button
            className="template-preview-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="template-preview-body">
          {Object.entries(templateHtml).map(([key, value]) => (
            <section
              key={key}
              className="template-preview-card"
            >
              <div className="template-preview-card-header">
                📄 {titleMap[key] || key}
              </div>

              <div
                className="template-preview-table"
                dangerouslySetInnerHTML={{ __html: value }}
              />
            </section>
          ))}
        </div>

        <div className="template-preview-footer">
          <button
            className="primary-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}